import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/FooterSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/index.css");
